import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function CtaBanner() {
  const { t } = useLang();

  return (
    <section className="bg-slate-900 py-20 sm:py-24" data-testid="cta-banner">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 lg:flex-row lg:items-center">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-400">{t.cta.overline}</p>
          <h2 className="mt-4 max-w-2xl font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            {t.cta.title}
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
            {t.cta.desc}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <Link
            to="/contatti"
            data-testid="cta-banner-button"
            className="group flex shrink-0 items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-brand-amber"
          >
            {t.cta.button}
            <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
